module.exports = __webpack_public_path__ + "static/media/clip.d22538fc.svg";